const jsonSchema = [
  {
    name: 'dob',
    label: 'Date of Birth',
    type: 'text',
    required: true
  },
  {
    name: 'firstName',
    label: 'First Name',
    type: 'text',
    required: true
  },
  {
    name: 'lastName',
    label: 'Last Name',
    type: 'text',
    required: true
  },
  {
    name: 'email',
    label: 'Email',
    type: 'text',
    required: true
  }
];
export default jsonSchema;